import { idmApi } from './http';

export async function getAllProducts() {
  const response = await idmApi.get('/products');
  return response.data.data;
}

export async function createNewProduct(product) {
  const response = await idmApi.post('/products', { ...product });
  return response.data;
}

export async function updateProduct(id, product) {
  const response = await idmApi.put(`/products/${id}`, { ...product });
  return response.data;
}
